import React, { useState } from 'react'
import { Button } from '~/lib/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '~/lib/ui/dialog'
import safeParse from '~/lib/safeParse'
import he from 'he'
import { useFormatTime } from '~/hooks/useFormatTime'

const ViewCoachFeedbackDialog = ({ serviceRequest, children }) => {
  const [open, setOpen] = useState(false)
  const formatTime = useFormatTime()
  const {
    completedAt,
    coachMessage,
    coachNotes,
    coachDocuments = [],
    coachName,
  } = serviceRequest || {}
  const displayCompletedAt = formatTime(completedAt)

  const formattedMessage = coachMessage
    ? safeParse(he.decode(coachMessage.replace(/\n/g, '<br />')))
    : ''

  const hidden = coachNotes?.includes('(hidden)')

  return (
    <Dialog
      open={open}
      onOpenChange={() => setOpen(!open)}
      className="rounded-2xl"
    >
      <DialogTrigger asChild className="cursor-pointer">
        <Button
          variant="link"
          className="justify-start font-normal text-intoo-blue-medium hover:text-link"
        >
          {children}
        </Button>
      </DialogTrigger>
      <DialogContent
        className="font-roboto lg:max-w-3xl xl:max-w-5xl"
        variant="default"
        dialogCloseClass="text-black"
      >
        <DialogHeader>
          <DialogTitle className="text-left" asChild>
            <h2 className="text-2xl">Coach Feedback</h2>
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Feedback submitted by Coach {coachName} on {displayCompletedAt}.
        </DialogDescription>
        <div className="px-4 pb-4">
          <div className="mb-4">
            <div className="text-lg font-medium">Internal Coach Note:</div>
            <div className="mt-2">
              {hidden ? 'This note is hidden.' : coachNotes}
            </div>
          </div>
          {coachDocuments.length > 0 && (
            <div className="flex flex-col space-y-2">
              {coachDocuments.map((doc, index) => (
                <a
                  key={index}
                  href={doc.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-intoo-blue-medium hover:underline"
                >
                  {doc.fileName || `Document ${index + 1}`}
                </a>
              ))}
            </div>
          )}
          {coachMessage && (
            <div className="mt-4">
              <p className="text-lg font-medium">
                Coach Message Shared with Candidate:
              </p>
              <p className="mt-2">{formattedMessage}</p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ViewCoachFeedbackDialog
